import * as React from 'react'
import { useVehicleForm } from '../../context/VehicleFormContext'
import { TextField } from '@/ui/form/controls/TextField'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const TachographStage = () => {
  const { data, setData } = useVehicleForm()
  const { t } = useLocalize()

  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-flex-1">
        <p className="tw-text-lg tw-font-semibold tw-text-content-base">
          {t('vehicleModule.tachograph')}
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <TextField
          label={t('vehicleBasics.tachograph-manufacturer')}
          placeholder={t('vehicleModule.placeholder-type')}
          value={data?.tachographManufacturer || ''}
          onChange={(e) =>
            setData({ ...data, tachographManufacturer: e.target.value })
          }
        />
        <TextField
          label={t('vehicleBasics.tachograph-generation')}
          placeholder={t('vehicleModule.placeholder-type')}
          value={data?.tachographGeneration || ''}
          onChange={(e) =>
            setData({ ...data, tachographGeneration: e.target.value })
          }
        />
      </div>
    </div>
  )
}

export default TachographStage
